// extracted by mini-css-extract-plugin
export default {"readMore":"HideExtensiveText-module__readMore__KLDun","button":"HideExtensiveText-module__button__NKsGL"};